import React from 'react'
import { Button, styled } from '@mui/material'
import Link from 'next/link'
import SwapVertIcon from '@mui/icons-material/SwapVert'

const StyledButton = styled(Button)`
  width: 32px;
  min-width: 32px;
  height: 32px;
  background: #bfff0b;

  border: 1px solid transparent;

  > svg {
    color: #000;
  }

  :hover {
    background: transparent;
    border-color: #bfff0b;

    > svg {
      color: #bfff0b;
    }
  }
`

const SwitchActionButton = ({ handleSwitch }: { handleSwitch: () => void }) => {
  return (
    <StyledButton
      onClick={() => {
        handleSwitch()
      }}
    >
      <SwapVertIcon />
    </StyledButton>
  )
}

export default SwitchActionButton
